import React, { useEffect, useState } from 'react'
import {
  DepositPixPingBody,
  DepositPixPingContainer,
  DepositPixPingContent,
  DepositPixPingTitle,
} from './styles'
import { Text, Title } from '../../atoms/text'
import UserKeySelector from '../../atoms/userKeySelector'
import CpfImage from '../../../images/pix-ping/cpf-icon.svg'
import EmailImage from '../../../images/pix-ping/email-icon.svg'
import PhoneImage from '../../../images/pix-ping/cell-icon.svg'
import OtherPixImage from '../../../images/pix-ping/add-pix.svg'
import PropTypes from 'prop-types'
import useDeviceDetect from '../../../hooks/useDeviceDetect'
import { STEPS } from '../../organisms/deposit/utils'
import ConfirmPixStep from './confirmPixStep'
import { usePaymentDrawerContext } from '../../../context/paymentDrawerProvider'
import { useTranslation } from '../../../context/translationProvider'
import { useEventTracking } from '../../../context/eventTrackingProvider'

const USER_PIX_KEYS = () => {
  const { translate } = useTranslation()

  return [
    {
      id: 1,
      icon: CpfImage,
      title: 'CPF',
    },
    {
      id: 2,
      icon: EmailImage,
      title: translate('userProfile.email'),
    },
    {
      id: 3,
      icon: PhoneImage,
      title: translate('deposit.pixPing.mobile.label'),
    },
    {
      id: 4,
      icon: OtherPixImage,
      title: translate('deposit.pixPing.randomKey.label'),
    },
  ]
}

const PIX_PING_EVENTS = {
  0: 'Cpf',
  1: 'Email',
  2: 'Mobile',
  3: 'Random',
}

const DepositPixPing = (props) => {
  const { currentStep, setCurrentStep, openDepositFlowFromPixPing } = props
  const [selectedPixKey, setSelectedPixKey] = useState(null)
  const { isOpen } = usePaymentDrawerContext()
  const { isMobile } = useDeviceDetect()
  const { trackEvent, EVENT_NAMES, EVENT_LOCATIONS } = useEventTracking()

  useEffect(() => {
    if (isOpen) {
      setCurrentStep(STEPS.SELECT_PIX)
    }
  }, [isOpen])

  useEffect(() => {
    if (!selectedPixKey) return

    trackEvent(
      EVENT_NAMES.SCREEN_LOADED,
      {
        screen_name: EVENT_LOCATIONS.PIX_PING_CONFIRMATION,
        pix_key_type: PIX_PING_EVENTS[selectedPixKey - 1],
      },
      true
    )
  }, [selectedPixKey])

  useEffect(() => {
    trackEvent(EVENT_NAMES.SCREEN_LOADED, {
      screen_name: EVENT_LOCATIONS.PIX_PING_START
    }, true)
  }, [])

  const renderStepContent = () => {
    switch (currentStep) {
      case STEPS.SELECT_PIX:
        return (
          <SelectPixStep
            setCurrentStep={setCurrentStep}
            setSelectedPixKey={setSelectedPixKey}
          />
        )
      case STEPS.CONFIRM_PIX:
        return (
          <ConfirmPixStep
            setCurrentStep={setCurrentStep}
            selectedPixKey={selectedPixKey}
            openDepositFlowFromPixPing={openDepositFlowFromPixPing}
            trackEvent={trackEvent}
            eventPixType={PIX_PING_EVENTS[selectedPixKey - 1]}
          />
        )
      default:
        return null
    }
  }

  return (
    <DepositPixPingContainer
      isDepositFlow={currentStep === STEPS.CONFIRM_PIX}
      isMobile={isMobile}
    >
      <DepositPixPingContent>{renderStepContent()}</DepositPixPingContent>
    </DepositPixPingContainer>
  )
}

DepositPixPing.propTypes = {
  currentStep: PropTypes.number.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
  openDepositFlowFromPixPing: PropTypes.func.isRequired,
}

const SelectPixStep = (props) => {
  const { setCurrentStep, setSelectedPixKey } = props
  const { translate } = useTranslation()

  return (
    <>
      <DepositPixPingTitle>
        <Title level={3} style={{ fontSize: '24px' }}>
          {translate('deposit.pixPing.select.title.line1')} <br />{' '}
          {translate('deposit.pixPing.select.title.line2')}
        </Title>
        <Text
          tagType="p"
          style={{ marginTop: '10px', fontSize: '17px', opacity: 0.5 }}
        >
          {translate('deposit.pixPing.select.description.line1')} <br />{' '}
          {translate('deposit.pixPing.select.description.line2')}
        </Text>
      </DepositPixPingTitle>
      <DepositPixPingBody>
        {USER_PIX_KEYS().map((key) => (
          <UserKeySelector
            key={key.id}
            userKeyIcon={key.icon}
            title={key.title}
            onClick={() => {
              setSelectedPixKey(key.id)
              setCurrentStep(STEPS.CONFIRM_PIX)
            }}
          />
        ))}
      </DepositPixPingBody>
    </>
  )
}

SelectPixStep.propTypes = {
  setCurrentStep: PropTypes.func.isRequired,
  setSelectedPixKey: PropTypes.func.isRequired,
}

export default DepositPixPing
